import { render, staticRenderFns } from "./FairCrash.vue?vue&type=template&id=0e953a9e&scoped=true"
import script from "./FairCrash.vue?vue&type=script&lang=js"
export * from "./FairCrash.vue?vue&type=script&lang=js"
import style0 from "./FairCrash.vue?vue&type=style&index=0&id=0e953a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e953a9e",
  null
  
)

export default component.exports